import { Film, UsersRound } from 'lucide-react';

import { EmptyState, SkeletonText } from '../../components/ui';
import { useCharacterAvatarUrl } from '../../hooks';
import type { Character } from '../../types/api';
import { initials } from './lib';
import styles from './Characters.module.css';

type Kind = 'frame' | 'circle' | 'player';

interface Props {
  character: Character;
  kind: Kind;
}

export function CharacterAvatar({ character, kind }: Props) {
  const { data, isLoading } = useCharacterAvatarUrl(character.id, character.has_avatar);
  const isVideo = (data?.content_type ?? '').startsWith('video');

  if (kind === 'circle') {
    return (
      <span className={styles.avatarCircle}>
        {data && !isVideo ? (
          <img className={styles.avatarCircleMedia} src={data.url} alt={character.name} />
        ) : data && isVideo ? (
          <video
            className={styles.avatarCircleMedia}
            src={data.url}
            muted
            playsInline
            preload="metadata"
          />
        ) : (
          initials(character.name)
        )}
      </span>
    );
  }

  if (kind === 'player') {
    if (isLoading) return <SkeletonText lines={1} />;
    if (!data) {
      return (
        <EmptyState
          compact
          icon={<Film size={17} strokeWidth={1.5} />}
          title="Видео персонажа не загружено"
          description="Без него персонажа нельзя снимать."
        />
      );
    }
    return (
      <div className={styles.videoBox}>
        {isVideo ? (
          <video key={data.url} src={data.url} controls preload="metadata" playsInline />
        ) : (
          <img key={data.url} src={data.url} alt={`Аватар: ${character.name}`} />
        )}
      </div>
    );
  }

  if (!data) {
    return <UsersRound size={34} strokeWidth={1.1} aria-hidden="true" />;
  }
  return isVideo ? (
    <video className={styles.frameMedia} src={data.url} muted playsInline preload="metadata" />
  ) : (
    <img className={styles.frameMedia} src={data.url} alt="" loading="lazy" />
  );
}
